import { render, staticRenderFns } from "./pushPoster.vue?vue&type=template&id=4c092e37&scoped=true"
import script from "./pushPoster.vue?vue&type=script&lang=js"
export * from "./pushPoster.vue?vue&type=script&lang=js"
import style0 from "./pushPoster.vue?vue&type=style&index=0&id=4c092e37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c092e37",
  null
  
)

export default component.exports